var _path, _rect, _path2, _path3, _path4, _mask, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgContactsNavigation = function SvgContactsNavigation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13C14.1569 13 15.5 11.6569 15.5 10C15.5 8.34315 14.1569 7 12.5 7C10.8431 7 9.5 8.34315 9.5 10C9.5 11.6569 10.8431 13 12.5 13Z",
    stroke: "#4F4E65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 19,
    height: 22,
    rx: 2,
    stroke: "#4F4E65",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8L4.5 8",
    stroke: "#4F4E65",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12L4.5 12",
    stroke: "#4F4E65",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16L4.5 16",
    stroke: "#4F4E65",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_1932_17951",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18C6.5 14.6863 9.18629 12 12.5 12C15.8137 12 18.5 14.6863 18.5 18H6.5Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18C4.5 13.5817 8.08172 10 12.5 10C16.9183 10 20.5 13.5817 20.5 18H16.5C16.5 15.7909 14.7091 14 12.5 14C10.2909 14 8.5 15.7909 8.5 18H4.5ZM18.5 18H6.5H18.5ZM4.5 18C4.5 13.5817 8.08172 10 12.5 10V14C10.2909 14 8.5 15.7909 8.5 18H4.5ZM12.5 10C16.9183 10 20.5 13.5817 20.5 18H16.5C16.5 15.7909 14.7091 14 12.5 14V10Z",
    fill: "#4F4E65",
    mask: "url(#path-6-inside-1_1932_17951)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContactsNavigation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contacts-navigation.96c51c7cc325814befba6eefd327fd79.svg";